import{m as t}from"./chunk-HBP5N4FR.js";t();var i=s=>/\d/.test(s);export{i as a};
//# sourceMappingURL=chunk-63OK7TX5.js.map
